import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../components/ToastifyNotification";
import {
  GetMessageById,
  MarkMessageAsRead
} from "../../../api/messaging/messageAPI";

const ViewMessage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const user = useSelector(state => state?.authReducer?.user);
  const [message, setMessage] = useState(null);

  /* ---------------------------------
     FETCH MESSAGE
  ----------------------------------*/
  const fetchMessage = async () => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await GetMessageById(id);
      if (response.success) {
        setMessage(response.data);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message || error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  useEffect(() => {
    if (id) fetchMessage();
  }, [id]);

  if (!message) return null;

  /* ---------------------------------
     HELPERS
  ----------------------------------*/
  const renderUsers = users =>
    users?.map(u => u.userId?.userName).join(", ");

  return (
    <Fragment>
      <Breadcrumb parent="Messages" title="View Message" />

      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8">

            {/* SUBJECT */}
            <div className="mb-3">
              <h4 className="fw-bold">{message.subject}</h4>
            </div>

            {/* HEADER */}
            <div className="card mb-3 shadow-sm">
              <div className="card-body">
                <div className="d-flex justify-content-between">

                  <div>
                    <div className="fw-bold">
                      From: {message.fromUserId?.userName || "System"}
                    </div>

                    <div className="text-muted">
                      To: {renderUsers(message.toUserIds)}
                    </div>

                    {message.ccUserIds?.length > 0 && (
                      <div className="text-muted">
                        Cc: {renderUsers(message.ccUserIds)}
                      </div>
                    )}
                  </div>

                  <div className="text-muted small">
                    {new Date(message.createdAt).toLocaleString()}
                  </div>

                </div>
              </div>
            </div>

            {/* MESSAGE BODY */}
            <div className="card shadow-sm">
              <div className="card-body" style={{ minHeight: "200px" }}>
                <p style={{ whiteSpace: "pre-wrap" }}>
                  {message.message}
                </p>
              </div>
            </div>

            {/* ACTIONS */}
            <div className="mt-3 d-flex justify-content-between">
              <button
                className="btn btn-outline-primary"
                onClick={() => navigate(-1)}
              >
                ← Back
              </button>
            </div>

          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ViewMessage;
